// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimFilterPanel-cls1_y4G","cls2":"ClaimFilterPanel-cls2_fiX ClaimFilterPanel-cls1_y4G","active":"ClaimFilterPanel-active_4ix"};